import { render, staticRenderFns } from "./add.html?vue&type=template&id=99b13814&scoped=true&"
import script from "./add.js?vue&type=script&lang=js&"
export * from "./add.js?vue&type=script&lang=js&"
import style0 from "./add.scss?vue&type=style&index=0&id=99b13814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b13814",
  null
  
)

export default component.exports